import React from "react";
import Skeleton from "react-loading-skeleton";
import "../../stylesheet/components/sections/SectionCard.scss";

const SectionCardSkeleton: React.FC = () => {
  return (
    <div className="section-card skeleton card border-0 shadow-sm">
      <div className="skeleton-text-row">
        <Skeleton />
      </div>
      <div className="skeleton-text-row-1">
        <Skeleton />
      </div>
      <div className="skeleton-text-row-1">
        <Skeleton />
      </div>
    </div>
  );
};

export default SectionCardSkeleton;
